module.exports = __webpack_public_path__ + "static/media/100.97967968.png";